import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_7x3sp6fhe7: FaireBrandEntity = {
  token: "b_7x3sp6fhe7",
  type: "brand",
  name: "Boho + Babe",
  avatarUrl:
    "https://cdn.faire.com/fastly/f6958d0917673ab676115d6415087880bafdb668d1ebdeac586d08be2c619d56.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/9ef0b84bca8839ce5a7c3d0a47ce5b821e0c8a830aad3362f964ae2e7a6444b9.png",
  logoUrl:
    "https://cdn.faire.com/fastly/f6958d0917673ab676115d6415087880bafdb668d1ebdeac586d08be2c619d56.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/9ef0b84bca8839ce5a7c3d0a47ce5b821e0c8a830aad3362f964ae2e7a6444b9.png",
  location: "Larsen, WI, USA",
  minimumOrderDollars: 20,
  rating: 5,
  reviewCount: 321,
  isInsider: true,
  description:
    "Hello! My name is Kayla and I have a passion for all things baby. I love keeping up with new trends. My brand aesthetic has lots of boho vibes. Happy shopping!",
  meta: {
    source: "api",
    importedAt: "2026-03-25T23:44:53.305Z",
    importedBy: "entity-db-cli",
  },
};
